const calculateLeftScroll = (
  listElement: HTMLElement,
  target: HTMLElement,
  targetIndex: number
): number => {
  const children = Array.from(listElement.childNodes);
  const widthData = children.map((element) => {
    const htmlElement = element as HTMLElement;

    return htmlElement.offsetWidth;
  });

  const shiftToLeft = widthData
    .slice(0, targetIndex)
    .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

  const centeredOffset = (listElement.offsetWidth - target.offsetWidth) / 2;

  return shiftToLeft - centeredOffset;
};

const Helpers = {
  calculateLeftScroll,
};

export default Helpers;
